import ArticleDetailMain, { ArticleDetailMainProps } from "./ArticleDetailMain";

export { ArticleDetailMain, ArticleDetailMainProps };

export default ArticleDetailMain;
